import * as THREE from "three";
import { OrbitControls } from "three/addons/controls/OrbitControls.js";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import * as OBC from "@thatopen/components";
import * as WEBIFC from "web-ifc";
import * as OBCF from "@thatopen/components-front";
import * as BUI from "@thatopen/ui";
// import * as BUI from "../../bui/index"
import * as CUI from "@thatopen/ui-obc";
// import * as CUI from '../../obc/index'
import { message } from "antd";

export let components: OBC.Components,
  container: HTMLElement | null = null,
  world:
    | OBC.SimpleWorld<
        OBC.SimpleScene,
        OBC.SimpleCamera,
        OBCF.PostproductionRenderer
      >
    | OBC.World
    | any,
  world2D: OBC.SimpleWorld<
    OBC.SimpleScene,
    OBC.SimpleCamera,
    OBCF.RendererWith2D
  >,
  grids: any,
  grid: any,
  mousePoint: any, // 鼠标位置
  cameraPosition: THREE.Vector3, // 相机对焦位置
  modelsList: any[] = [], // 存放所有的模型
  bufferList: Uint8Array[] = [], // ifc模型
  fragmentsManager: OBC.FragmentsManager, // 碎片管理
  fragmentIFCLoader: OBC.IfcLoader, // ifc碎片加载
  streamerLoader: OBCF.IfcStreamer,
  tiler: OBC.IfcGeometryTiler, // ifc模型切割工具
  propsStreamer: OBC.IfcPropertiesTiler, // 属性流
  indexer: any, // 索引
  clipper: any, // 裁剪工具
  map: any, // 地图
  isInit = false;

let options = {
  showClickFocus: false, // 点击摄像机聚焦到模型
  showMousePoint: true, // 显示鼠标位置
  showHeightLight: false, // 点击显示高度光
  showRelationTree: false, // 显示关系树
  showModelList: true, // 显示模型列表
  showViewCube: true, // 显示viewCube
}; // 配置信息

let enableds = {
  dimensions: false,
  angles: false,
  area: false,
  edge: false,
  face: false,
  volume: false,
}; // 是否开启测量

export type hasPanelsType = {
  map: boolean;
  camera: boolean;
  cliper: boolean;
  post: boolean;
  models: boolean;
  property: boolean;
  classifications: boolean;
  relations: boolean;
  exploder: boolean;
};
export let hasPanels: hasPanelsType = {
  map: false,
  camera: false,
  cliper: false,
  post: false,
  models: false,
  property: false,
  classifications: false,
  relations: false,
  exploder: false,
}; // 是否创建了面板

/**
 * 初始化3D和2D世界场景
 *
 * @param el 页面容器的ID，默认为'bim-viewport'
 * @param option 可选参数，用于自定义初始化过程
 */
export function initial(el: string = "bim-viewport", option?: any) {
  // container = document.getElementById(el)
  const suBimViewer = document.getElementById("su-bim-viewer");
  container = document.createElement("bim-viewport");
  container.className = "worldContainer3D";
  suBimViewer?.prepend(container);
  if (!suBimViewer || !container) return;
  components = new OBC.Components();
  const worlds = components.get(OBC.Worlds);
  streamerLoader = components.get(OBCF.IfcStreamer);
  // world = worlds.create<OBC.SimpleScene, OBC.SimpleCamera, OBC.SimpleRenderer>()
  world = worlds.create<
    OBC.SimpleScene,
    OBC.SimpleCamera,
    OBCF.PostproductionRenderer
  >();

  world2D = worlds.create<
    OBC.SimpleScene,
    OBC.SimpleCamera,
    OBCF.RendererWith2D
  >();

  const casters = components.get(OBC.Raycasters); // 光投影射线

  // 3D
  world.scene = new OBC.SimpleScene(components);
  // world.renderer = new OBC.SimpleRenderer(components, container);
  world.renderer = new OBCF.PostproductionRenderer(components, container);

  // world.camera = new OBC.SimpleCamera(components);
  world.camera = new OBC.OrthoPerspectiveCamera(components);

  world.renderer.postproduction.enabled = true;
  
  cameraTypeSet('Orbit', 'Perspective')
  world.scene.setup();

  // 2D
  world2D.scene = new OBC.SimpleScene(components);
  world2D.renderer = new OBCF.RendererWith2D(components, container);
  // world2D.camera = new OBC.SimpleCamera(components);
  world2D.camera = new OBC.OrthoPerspectiveCamera(components);
  // world2D.camera.controls.setLookAt(5, 5, 5, 0, 0, 0);

  components.init();
  container.appendChild(world2D.renderer.three2D.domElement);

  // 网格
  grids = components.get(OBC.Grids);
  grid = grids.create(world);

  world.scene.three.background = null;

  world.renderer.postproduction.customEffects.excludedMeshes.push(grid.three);

  // 添加坐标辅助器
  const axes = new THREE.AxesHelper(5);
  world.scene.three.add(axes);

  // 添加viewCube
  if(options.showViewCube) initViewCube(container)
    
  world.camera.controls.setLookAt(10, 10, 10, 0, 0, 0);
  // 轨道控制器
  // const controls = new OrbitControls( world.camera.three, world.renderer.three.domElement );

  isInit = true;
  // 监听鼠标经过模型时的位置
  const caster = casters.get(world);
  if (world.renderer && options?.showMousePoint) {
    const canvas = world.renderer.three.domElement;
    canvas.addEventListener("pointermove", () => {
      const result = caster.castRay(modelsList);
      if (!result) return;
      // if (!(result.object of THREE.Mesh)) return;
      // if (result.faceIndex === undefined) return;
      const { point = { x: 0, y: 0, z: 0 } } = { ...result };
      mousePoint = point;
    });
  }
  BUI.Manager.init();
  CUI.Manager.init();

  // 动画
  function animate() {
    requestAnimationFrame(animate);
    // controls.update();
  }
  // animate();

  // window.onmousedown = () => {
  //   if(!modelsList) return;
  //   const result = caster.castRay(modelsList);
  //   if(!result) return;
  //   console.log(result, 'result')
  //   const {x=0, y=0, z=0 } = result.point
  //   cameraPosition = result.point;
  //   world.camera.controls.setLookAt(5, 5, 5, ...cameraPosition);

  // };

  if (options?.showHeightLight) {
    heightLightMarker();
  }

  if (options?.showRelationTree) {
    // 开启关系树
    relationsOn();
  }
  if (options?.showModelList) {
    // 开启模型列表
    modelsListOn();
  }
}

const initViewCube = (container: any) => {
  const viewCube = document.querySelector("bim-view-cube") || document.createElement("bim-view-cube");
  viewCube.size = 80;
  viewCube.topText = "上";
  viewCube.leftText = "左";
  viewCube.rightText = "右";
  viewCube.bottomText = "下";
  viewCube.frontText = "前";
  viewCube.backText = "后"; 

  viewCube.camera = world.camera.three;
  container.append(viewCube);
  world.camera.controls.addEventListener("update", () =>
    viewCube.updateOrientation()
  );
  // 点击事件
  viewCube.addEventListener("rightclick",(e) => {
    resetBbox(viewCube)      
  })
  viewCube.addEventListener("leftclick",(e) => {
    resetBbox(viewCube)
  })
  viewCube.addEventListener("topclick",(e) => {
    resetBbox(viewCube)
  })
  viewCube.addEventListener("bottomclick",(e) => {
    resetBbox(viewCube)
  })
  viewCube.addEventListener("frontclick",(e) => {
    resetBbox(viewCube)
  })
  viewCube.addEventListener("backclick",(e) => {
    resetBbox(viewCube)
  })
}

const heightLightMarker = async () => {
  // 选中高亮
  const highlighter = components.get(OBCF.Highlighter);
  if (!highlighter.isSetup) {
    highlighter.setup({ world });
  }

  highlighter.zoomToSelection = options.showClickFocus ? true : false;

  const Marker = components.get(OBCF.Marker);

  let nodeKey: string, nodeValue: any;
  highlighter.events.select.onHighlight.add((data: any) => {
    nodeKey = Object.keys(data)[0];
    nodeValue = Array.from(data[nodeKey]);
    Marker.dispose();
    modelsList.forEach((item) => {
      item.getProperties(nodeValue[0]).then((res: any) => {
        const { value = "" } = { ...res?.Name };
        if (value) {
          const elementLabel = `<span style='color: #fff; background: #6528d7; opacity: 0.8; padding: 5px 10px; display: inline-block'>${value} </span>`;
          Marker.create(world, elementLabel, mousePoint, true);
        }
      });
    });
  });
  highlighter.events.select.onClear.add(() => {
    Marker.dispose();
  });
};

interface streamerProps {
  url: string;
  geometry: string;
  property?: string;
  propertyAll?: string;
  threshold?: number;
  maxHiddenTime?: number;
  maxLostTime?: number;
  cb?: (v: boolean) => void;
}
/**
 * 初始化流媒体加载器
 *
 * @param props 流媒体加载器配置参数
 * @param props.url 流媒体资源地址
 * @param props.geometry 流媒体模型几何体地址
 * @param props.property 流媒体模型属性地址
 * @param props.propertyAll 全量模型属性地址
 * @param props.threshold 阈值
 * @param props.maxHiddenTime 最大隐藏时间
 * @param props.maxLostTime 最大丢失时间
 * @param props.cb 回调函数
 * @returns 无返回值
 */
export const streamerInit = async (props: streamerProps) => {
  const {
    url,
    geometry,
    property,
    propertyAll,
    threshold = 10,
    maxHiddenTime = 1000,
    maxLostTime = 3000,
    cb,
  } = props;
  if (!url && !geometry) return;

  streamerLoader.world = world;
  streamerLoader.dbCleaner.enabled = true;
  streamerLoader.url = url;
  // 配置阈值
  streamerLoader.culler.threshold = threshold;
  streamerLoader.culler.maxHiddenTime = maxHiddenTime;
  streamerLoader.culler.maxLostTime = maxLostTime;
  if (!geometry) return;
  const rawGeometryData = await fetch(`${url}${geometry}`);
  const geometryData = await rawGeometryData.json();
  let propertiesData: any;
  if (property) {
    streamerLoader.components.enabled = true;
    const rawPropertiesData = await fetch(`${url}${property}`);
    propertiesData = await rawPropertiesData.json();
  }

  const model = await streamerLoader.load(geometryData, true, propertiesData);
  modelsList.push(model);

  if (propertyAll) {
    const propertyFile = await fetch(`${url}${propertyAll}`);
    const propertyFileData = await propertyFile.json();
    model.setLocalProperties(propertyFileData);
  }

  // 选中高亮
  heightLightMarker();
  cb?.(true);
  world.camera.fit(modelsList);
  world.camera.controls.addEventListener("sleep", () => {
    streamerLoader.culler.needsUpdate = true;
  });
  streamerLoader.useCache = true;
};

/**
 * 加载ifc文件
 *
 * @param file 要加载的文件对象
 * @param cb 加载完成后的回调函数，参数为加载结果（true/false）
 */
export async function loadIfcFile(file: any, cb?: (v: boolean) => void) {
  try {
    fragmentIFCLoader = components.get(OBC.IfcLoader);
    await fragmentIFCLoader.setup();

    const data = await file.arrayBuffer();
    const buffer = new Uint8Array(data);
    if (!buffer) {
      cb?.(false);
      return;
    }
    bufferList.push(buffer);
    const model = await fragmentIFCLoader.load(
      buffer,
      true,
      file.name || "ifc"
    );

    world.scene.three.add(model);
    modelsList.push(model);
    // world.camera.fit(modelsList);
    world.camera.controls.setLookAt(0, 0, 5, 0, 0, 0);
    if (model.children) {
      for (const child of model.children) {
        if (child instanceof THREE.Mesh) {
          world.meshes.add(child);
        }
      }
    }
    // 放入索引器
    indexer = components.get(OBC.IfcRelationsIndexer);
    if (model.hasProperties) await indexer.process(model);

    // 增加导航对象
    const navigator = components.get(OBCF.Civil3DNavigator);
    navigator.world = world;
    navigator.draw(model);
    cb?.(true);
  } catch (err) {
    cb?.(false);
    console.error("Error loading IFC.");
    console.error(err);
  }
}
// 加载gltf文件
export async function loadGltfFile(file: any, cb?: (v: boolean) => void) {
  try {
    if (!file || typeof file.arrayBuffer !== "function") {
      cb?.(false);
      return;
    }

    const data = await file.arrayBuffer();
    const loader = new GLTFLoader();
    const gltf = await loader.parseAsync(data, "");
    const model = gltf.scene;
    model.name = file.name || "gltf";

    world.scene.three.add(model);
    model.traverse((object) => {
      if (object instanceof THREE.Mesh) {
        world.meshes.add(object);
      }
    });
    modelsList.push(model);
    world.camera.fit(modelsList);
    cb?.(true);
  } catch (err) {
    console.error("Error loading GLTF.", err);
    cb?.(false);
  }
}
/**
 * 异步加载frag文件
 *
 * @param file 要加载的文件对象
 * @param cb 加载完成后的回调函数，参数为加载结果（true/false）
 */
export async function loadFragFile(file: any, cb?: (v: boolean) => void) {
  try {
    fragmentsManager = components.get(OBC.FragmentsManager);
    const data = await file.arrayBuffer();
    const buffer = new Uint8Array(data);
    if (!buffer) {
      cb?.(false);
      return;
    }
    bufferList.push(buffer);
    const model = fragmentsManager.load(buffer, {
      name: file.name || "frag",
    });
    world.scene.three.add(model);
    // world.camera.controls.setLookAt(5, 5, 5, 0, 0, 0);
    modelsList.push(model);
    if (model.children) {
      for (const child of model.children) {
        if (child instanceof THREE.Mesh) {
          world.meshes.add(child);
        }
      }
    }
    world.camera.fit(modelsList);
    // 放入索引器
    indexer = components.get(OBC.IfcRelationsIndexer);
    fragmentsManager = components.get(OBC.FragmentsManager);
    if (model.hasProperties) await indexer.process(model);

    // 增加导航对象
    const navigator = components.get(OBCF.Civil3DNavigator);
    navigator.world = world;
    navigator.draw(model);

    // 添加圆形高亮 并定位
    //   const sphere = new THREE.Sphere(undefined, 20);

    //   navigator.onHighlight.add(({ point }) => {
    //     sphere.center.copy(point);
    //     world.camera.controls.fitToSphere(sphere, true);
    //   });
    cb?.(true);
  } catch (err) {
    console.error("Error loading FRAG.", err);
    cb?.(false);
  }
}

// 重定位包围盒
export const resetBbox = async (viewCube?: any) => {
  const fragmentBbox = components.get(OBC.BoundingBoxer);
  if (modelsList?.length  == 0) {
    await world.camera.controls.setLookAt(10, 10, 10, 0, 0, 0);
    setTimeout(() => {viewCube?.updateOrientation()}, 1)
    return;
  }
  fragmentBbox.add(modelsList[0]);

  const bbox = fragmentBbox.getMesh();
  if (!bbox) return;
  fragmentBbox.reset(); 
  await world.camera.controls?.fitToBox?.(bbox);
  setTimeout(() => {viewCube?.updateOrientation()}, 10)
};

export const focusHome = () => {
  if(modelsList.length) {
    // world.camera.fit(modelsList);
    world.camera.controls.setLookAt(0, 0, 5, 0, 0, 0);
  } else {
    world.camera.controls.setLookAt(10, 10, 10, 0, 0, 0);
  }  
};

// 裁剪模型
export const clipperModel = () => {
  if (!isInit) return;
  if (hasPanels.cliper) {
    return;
  }
  const casters = components.get(OBC.Raycasters);
  casters.get(world);
  clipper = components.get(OBC.Clipper);
  clipper.enabled = true;
  if (!container) return;
  container.ondblclick = () => {
    if (clipper.enabled) {
      clipper.create(world);
    }
  };
  window.onkeydown = (event) => {
    if (event.code === "Delete" || event.code === "Backspace") {
      if (clipper.enabled) {
        clipper.delete(world);
      }
    }
  };

  // BUI.Manager.init();
  const panel = BUI.Component.create<BUI.PanelSection>(() => {
    return BUI.html`
      <div class="options-menu" id="clipPanel">
        <bim-panel-section label="说明">        
          <bim-label>双击创建裁剪</bim-label>
          <bim-label>Del键清除裁剪</bim-label>   
        </bim-panel-section>
        <bim-panel-section label="设置"">
            
          <bim-checkbox label="开启裁剪" checked 
            @change="${({ target }: { target: BUI.Checkbox }) => {
              clipper.enabled = target.value;
            }}">
          </bim-checkbox>
          
          <bim-checkbox label="显示裁剪" checked 
            @change="${({ target }: { target: BUI.Checkbox }) => {
              clipper.visible = target.value;
            }}">
          </bim-checkbox>
        
          <bim-color-input 
            label="颜色" color="#202932" 
            @input="${({ target }: { target: BUI.ColorInput }) => {
              clipper.material.color.set(target.color);
            }}">
          </bim-color-input>
          
          <bim-number-input 
            slider step="0.01" label="透明度" value="0.2" min="0.1" max="1"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              clipper.material.opacity = target.value;
            }}">
          </bim-number-input>
          
          <bim-number-input 
            slider step="0.1" label="尺寸" value="5" min="2" max="10"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              clipper.size = target.value;
            }}">
          </bim-number-input>
          
          <bim-button 
            label="取消裁剪" 
            @click="${() => {
              clipper.deleteAll();
            }}">  
          </bim-button>       
        </bim-panel-section>
      </div>
      `;
  });

  const clipperSetDom = document.getElementById("clipperSet");
  if (!clipperSetDom) return;
  clipperSetDom.innerHTML = "";
  clipperSetDom.append(panel);
  hasPanels.cliper = true;
};

// 相机设置按钮模式
export const cameraTypeSet = (cameraType: OBC.NavModeID, projectionType?: OBC.CameraProjection) => {
  const { current } = world.camera.projection; 
  console.log(current, 'current')
  world.camera.set(cameraType);
  if (projectionType) world.camera.projection.set(projectionType)
}
// 相机设置
export const cameraOn = () => {
  const dom = document.getElementById("cameraPanel");
  if (dom) {
    return;
  }

  // BUI.Manager.init();
  const panel = BUI.Component.create<BUI.PanelSection>(() => {
    return BUI.html`
    <div class="options-menu" id="cameraPanel">

      <bim-panel-section >
          <bim-dropdown required label="导航模式" 
            @change="${({ target }: { target: BUI.Dropdown }) => {
              const selected = target.value[0] as OBC.NavModeID;

              const { current } = world.camera.projection;
              const isOrtho = current === "Orthographic";
              const isFirstPerson = selected === "FirstPerson";
              if (isOrtho && isFirstPerson) {
                alert("First person is not compatible with ortho!");
                target.value[0] = world.camera.mode.id;
                return;
              }
              world.camera.set(selected);
            }}">

          <bim-option checked label="Orthographic"></bim-option>
          <bim-option label="FirstPerson"></bim-option>
          <bim-option label="Plan"></bim-option>
        </bim-dropdown>
      
        <bim-dropdown required label="Camera projection" 
            @change="${({ target }: { target: BUI.Dropdown }) => {
              const selected = target.value[0] as OBC.CameraProjection;
              const isOrtho = selected === "Orthographic";
              const isFirstPerson = world.camera.mode.id === "FirstPerson";
              if (isOrtho && isFirstPerson) {
                alert("First person is not compatible with ortho!");
                target.value[0] = world.camera.projection.current;
                return;
              }
              world.camera.projection.set(selected);
            }}">
          <bim-option checked label="正视角"></bim-option>
          <bim-option label="视锥角"></bim-option>
        </bim-dropdown>
 
        <bim-button 
          label="适应模型" 
          @click="${() => {
            world.camera.fit(modelsList);
          }}">  
        </bim-button> 

      </bim-panel-section> 
      
    </div>
  `;
  });

  // 相机控制
  world.camera?.projection?.onChanged.add(() => {
    const projection = world.camera.projection.current;
    grid.fade = projection === "Perspective";
  });
  const cameraSetDom = document.getElementById("cameraSet");
  if (!cameraSetDom) return;
  cameraSetDom.innerHTML = "";
  cameraSetDom.append(panel);
  hasPanels.camera = true;
};

export const postRendererOn = () => {
  const dom = document.getElementById("postPanel");
  if (dom) {
    return;
  }
  const { postproduction } = world.renderer;
  postproduction.enabled = true;
  console.log(grid, "grid");
  if (!grid?.three) return;
  postproduction.customEffects.excludedMeshes.push(grid.three);
  const ao = postproduction.n8ao.configuration;

  // BUI.Manager.init();
  const panel = BUI.Component.create<BUI.PanelSection>(() => {
    return BUI.html`
    <div class="options-menu" id="postPanel">
        <bim-panel-section collapsed label="伽马">
          <bim-checkbox checked label="伽马校正"
            @change="${({ target }: { target: BUI.Checkbox }) => {
              postproduction.setPasses({ gamma: target.value });
            }}">
          </bim-checkbox>
        </bim-panel-section>
        
        <bim-panel-section collapsed label="自定义特效" >
          <bim-checkbox checked label="启用特效"
            @change="${({ target }: { target: BUI.Checkbox }) => {
              postproduction.setPasses({ custom: target.value });
            }}">
          </bim-checkbox>    
          
          <bim-checkbox checked label="启用伽马校正"
            @change="${({ target }: { target: BUI.Checkbox }) => {
              postproduction.customEffects.glossEnabled = target.value;
            }}">
          </bim-checkbox>   
        
          <bim-number-input 
            slider step="0.01" label="透明度" 
            value="${postproduction.customEffects.opacity}" min="0" max="1"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              postproduction.customEffects.opacity = target.value;
            }}">
          </bim-number-input>  
              
          <bim-number-input 
            slider step="0.1" label="容差" 
            value="${postproduction.customEffects.tolerance}" min="0" max="6"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              postproduction.customEffects.tolerance = target.value;
            }}">
          </bim-number-input> 
                        
          <bim-color-input label="线条颜色" 
            @input="${({ target }: { target: BUI.ColorInput }) => {
              const color = new THREE.Color(target.value.color);
              postproduction.customEffects.lineColor = color.getHex();
            }}">
          </bim-color-input>  
        
          <bim-number-input 
            slider label="光泽指数" step="0.1" 
            value="${
              postproduction.customEffects.glossExponent
            }" min="0" max="5"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              postproduction.customEffects.glossExponent = target.value;
            }}">
          </bim-number-input>    
             
          <bim-number-input 
            slider label="最大光值" step="0.05" 
            value="${postproduction.customEffects.maxGloss}" min="-2" max="2"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              postproduction.customEffects.maxGloss = target.value;
            }}">
          </bim-number-input>  
                    
          <bim-number-input 
            slider label="最小光值" step="0.05" 
            value="${postproduction.customEffects.minGloss}" min="-2" max="2"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              postproduction.customEffects.minGloss = target.value;
            }}">
          </bim-number-input> 
          
        </bim-panel-section>
        
        <bim-panel-section collapsed label="环境光遮蔽">
        
          <bim-checkbox label="启用"
            @change="${({ target }: { target: BUI.Checkbox }) => {
              postproduction.setPasses({ ao: target.value });
            }}">
          </bim-checkbox>  
                  
          <bim-checkbox checked label="降噪"
            @change="${({ target }: { target: BUI.Checkbox }) => {
              ao.halfRes = target.value;
            }}">
          </bim-checkbox>  
                        
          <bim-checkbox label="屏幕空间半径"
            @change="${({ target }: { target: BUI.Checkbox }) => {
              ao.screenSpaceRadius = target.value;
            }}">
          </bim-checkbox>
          
                                
          <bim-color-input label="光照颜色" 
            @input="${({ target }: { target: BUI.ColorInput }) => {
              const color = new THREE.Color(target.value.color);
              ao.color.r = color.r;
              ao.color.g = color.g;
              ao.color.b = color.b;
            }}">
          </bim-color-input>     
          
          <bim-number-input 
            slider label="光照采样" step="1" 
            value="${ao.aoSamples}" min="1" max="16"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              ao.aoSamples = target.value;
            }}">
          </bim-number-input>    
              
          <bim-number-input 
            slider label="采样降噪" step="1" 
            value="${ao.denoiseSamples}" min="1" max="16"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              ao.denoiseSamples = target.value;
            }}">
          </bim-number-input>   
                    
          <bim-number-input 
            slider label="降噪半径" step="1" 
            value="${ao.denoiseRadius}" min="0" max="100"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              ao.denoiseRadius = target.value;
            }}">
          </bim-number-input>   
                         
          <bim-number-input 
            slider label="光照半径" step="1" 
            value="${ao.aoRadius}" min="0" max="16"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              ao.aoRadius = target.value;
            }}">
          </bim-number-input>  
                                
          <bim-number-input 
            slider label="距离下降" step="1" 
            value="${ao.distanceFalloff}" min="0" max="16"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              ao.distanceFalloff = target.value;
            }}">
          </bim-number-input> 
                                        
          <bim-number-input 
            slider label="光照强度" step="1" 
            value="${ao.intensity}" min="0" max="16"
            @change="${({ target }: { target: BUI.NumberInput }) => {
              ao.intensity = target.value;
            }}">
          </bim-number-input> 
          
        </bim-panel-section>
        
      </div>
      `;
  });

  const renderSetDom = document.getElementById("renderSet");
  if (!renderSetDom) return;
  renderSetDom.innerHTML = "";
  renderSetDom.append(panel);
  hasPanels.post = true;
};

// 长度测量
export const dimensionOn = () => {
  if (!container) return;
  const dimensions = components.get(OBCF.LengthMeasurement);
  dimensions.world = world;

  if (enableds.dimensions) {
    dimensions.deleteAll();
    dimensions.enabled = false;
    enableds.dimensions = false;
    return;
  }
  dimensions.enabled = true;
  enableds.dimensions = true;
  dimensions.snapDistance = 1;
  container.ondblclick = () => dimensions.create();
  window.onkeydown = (event) => {
    if (event.code === "Delete" || event.code === "Backspace") {
      dimensions.delete();
    }
  };
};

// 角度测量
export const angleOn = () => {
  if (!container) return;
  const angles = components.get(OBCF.AngleMeasurement);
  angles.world = world;
  if (enableds.angles) {
    angles.deleteAll();
    angles.enabled = false;
    enableds.angles = false;
    return;
  }
  angles.enabled = true;
  enableds.angles = true;

  container.ondblclick = () => angles.create();

  window.onkeydown = (event) => {
    if (event.code === "Delete" || event.code === "Backspace") {
      angles.deleteAll();
    }
  };
};

// 面积测量
export const areaOn = () => {
  if (!container) return;
  const areaDims = components.get(OBCF.AreaMeasurement);
  areaDims.world = world;
  if (enableds.area) {
    areaDims.deleteAll();
    areaDims.enabled = false;
    enableds.area = false;
    return;
  }
  areaDims.enabled = true;
  enableds.area = true;

  container.ondblclick = () => areaDims.create();
  container.oncontextmenu = () => areaDims.endCreation();
  window.onkeydown = (event) => {
    if (event.code === "Delete" || event.code === "Backspace") {
      areaDims.deleteAll();
    }
  };
};

// 鼠标经过显示测量信息
export const edgeOn = () => {
  if (!container) return;
  const dimensions = components.get(OBCF.EdgeMeasurement);
  dimensions.world = world;
  if (enableds.edge) {
    dimensions.deleteAll();
    dimensions.enabled = false;
    enableds.edge = false;
    return;
  }
  dimensions.enabled = true;
  enableds.edge = true;
  container.ondblclick = () => dimensions.create();

  let saved: number[][];

  window.addEventListener("keydown", (event) => {
    if (event.code === "KeyO") {
      dimensions.delete();
    } else if (event.code === "KeyS") {
      saved = dimensions.get();
      dimensions.deleteAll();
    } else if (event.code === "KeyL") {
      if (saved) {
        dimensions.set(saved);
      }
    }
  });
};

// 双击显示高亮区的面积
export const faceOn = () => {
  if (!container) return;
  const dimensions = components.get(OBCF.FaceMeasurement);
  dimensions.world = world;
  if (enableds.face) {
    dimensions.deleteAll();
    dimensions.enabled = false;
    enableds.face = false;
    return;
  }
  dimensions.enabled = true;
  enableds.face = true;
  container.ondblclick = () => dimensions.create();

  let saved: OBCF.SerializedAreaMeasure[];

  window.addEventListener("keydown", (event) => {
    if (event.code === "KeyO") {
      dimensions.delete();
    } else if (event.code === "KeyS") {
      saved = dimensions.get();
      dimensions.deleteAll();
    } else if (event.code === "KeyL") {
      if (saved) {
        dimensions.set(saved);
      }
    }
  });
};

// 点击显示物体体积
export const volumeOn = () => {
  const dimensions = components.get(OBCF.VolumeMeasurement);
  dimensions.world = world;

  if (enableds.volume) {
    dimensions.clear();
    dimensions.enabled = false;
    enableds.volume = false;
    return;
  }
  dimensions.enabled = true;
  enableds.volume = true;

  const highlighter = components.get(OBCF.Highlighter);
  highlighter.setup({ world });
  highlighter.events.select.onHighlight.add((event) => {
    if (enableds.volume) {
      dimensions.getVolumeFromFragments(event);
    }
  });

  highlighter.events.select.onClear.add(() => {
    dimensions.clear();
  });
};

export const clearMeasure = () => {
  const dimensions = components.get(OBCF.LengthMeasurement);
  if (enableds.dimensions) {
    dimensions.enabled = false;
    dimensions.deleteAll();
  }

  const angles = components.get(OBCF.AngleMeasurement);
  if (enableds.angles) {
    angles.enabled = false;
    angles.deleteAll();
  }

  const areaDims = components.get(OBCF.AreaMeasurement);
  if (enableds.area) {
    areaDims.enabled = false;
    areaDims.deleteAll();
  }

  const volumes = components.get(OBCF.VolumeMeasurement);
  if (enableds.volume) {
    volumes.enabled = false;
    volumes.clear();
  }

  const edges = components.get(OBCF.EdgeMeasurement);
  if (enableds.edge) {
    edges.deleteAll();
    edges.enabled = false;
    enableds.edge = false;
    return;
  }

  const faces = components.get(OBCF.FaceMeasurement);
  if (enableds.face) {
    faces.deleteAll();
    faces.enabled = false;
    enableds.face = false;
    return;
  }

  enableds = {
    ...enableds,
    dimensions: false,
    angles: false,
    area: false,
    edge: false,
    face: false,
    volume: false,
  };
};

// 模型列表
export const modelsListOn = () => {
  const dom = document.getElementById("modelsPanel");
  if (dom) {
    if (!hasPanels.models) {
      dom.style.display = "block";
      hasPanels.models = true;
    }
    return;
  }
  const [modelsList] = CUI.tables.modelsList({
    components,
    tags: { schema: true, viewDefinition: false },
    actions: { download: false, visibility: true, dispose: false },
  });

  // BUI.Manager.init();

  const panel = BUI.Component.create(() => {
    return BUI.html`
     <div id="modelsPanel" class="options-menu">
        ${modelsList}
     </div> 
    `;
  });
  const modelListDom = document.getElementById("modelList");
  if (!modelListDom) return;
  modelListDom.innerHTML = "";
  modelListDom?.append(panel);
  hasPanels.models = true;
};

// 元素属性
export const propertiesOn = async () => {
  const dom = document.getElementById("propertyPanel");
  if (dom) {
    return;
  }
  const [propertiesTable, updatePropertiesTable] = CUI.tables.elementProperties(
    {
      components,
      fragmentIdMap: {},
    }
  );

  propertiesTable.preserveStructureOnFilter = true;
  propertiesTable.indentationInText = false;
  const highlighter = components.get(OBCF.Highlighter);
  if (!highlighter.isSetup) {
    highlighter.setup({ world });
  }

  highlighter.events.select.onHighlight.add((fragmentIdMap) => {
    updatePropertiesTable({ fragmentIdMap });
  });

  highlighter.events.select.onClear.add(() =>
    updatePropertiesTable({ fragmentIdMap: {} })
  );

  // BUI.Manager.init();
  const propertiesPanel = BUI.Component.create(() => {
    const onTextInput = (e: Event) => {
      const input = e.target as BUI.TextInput;
      propertiesTable.queryString = input.value !== "" ? input.value : null;
    };

    const expandTable = (e: Event) => {
      const button = e.target as BUI.Button;
      propertiesTable.expanded = !propertiesTable.expanded;
      button.label = propertiesTable.expanded ? "收起" : "展开";
    };

    const copyAsTSV = async () => {
      await navigator.clipboard.writeText(propertiesTable.tsv);
    };

    return BUI.html`
      <div id="propertyPanel" class="options-menu">
          <div style="display: flex; gap: 0.5rem;">
            <bim-button @click=${expandTable} label=${
      propertiesTable.expanded ? "收起" : "展开"
    }></bim-button> 
          <bim-text-input @input=${onTextInput} placeholder="搜索属性" debounce="250"></bim-text-input>
          </div> 
          ${propertiesTable}
      </div>
    `;
  });
  const propertySetDom = document.getElementById("propertySet");
  if (!propertySetDom) return;
  propertySetDom.innerHTML = "";
  propertySetDom.append(propertiesPanel);
  hasPanels.property = true;
};

// 分类树列表
export const classificationsOn = async () => {
  if (hasPanels.classifications) {
    return;
  }

  const [classificationsTree, updateClassificationsTree] =
    CUI.tables.classificationTree({
      components,
      classifications: [],
    });
  const classifier = components.get(OBC.Classifier);
  fragmentsManager = components.get(OBC.FragmentsManager);
  if (modelsList.length) {
    classifier.byEntity(modelsList[0]);
    await classifier.byPredefinedType(modelsList[0]);
    const classifications = [
      { system: "entities", label: "Entities" },
      { system: "predefinedTypes", label: "Predefined Types" },
    ];

    updateClassificationsTree({ classifications });
  }
  fragmentsManager.onFragmentsLoaded.add(async (model) => {
    // This creates a classification system named "entities"
    classifier.byEntity(model);

    // This creates a classification system named "predefinedTypes"
    await classifier.byPredefinedType(model);

    // This classifications in the state of the classifications tree.
    // Is an array with the classification systems to be shown.
    // You can pass the system name directly, or an object with system and label keys.
    // The system key is the name in the classifier, and the label is how you want it to be shown in the table.
    const classifications = [
      { system: "entities", label: "Entities" },
      { system: "predefinedTypes", label: "Predefined Types" },
    ];

    updateClassificationsTree({ classifications });
  });

  // BUI.Manager.init();
  const panel = BUI.Component.create(() => {
    return BUI.html`
     <div id="classificationsPanel" class="options-menu">
        ${classificationsTree}
     </div> 
    `;
  });
  const classificationsTreeDom = document.getElementById("classificationsTree");
  if (!classificationsTreeDom) return;
  classificationsTreeDom.innerHTML = "";
  classificationsTreeDom.append(panel);
  hasPanels.classifications = true;
};

// 关系树
export const relationsOn = async () => {
  const dom = document.getElementById("relationsPanel");
  if (dom) {
    return;
  }
  // 选中高亮
  const highlighter = components.get(OBCF.Highlighter);
  if (!highlighter.isSetup) {
    highlighter.setup({ world });
  }
  const indexer = components.get(OBC.IfcRelationsIndexer);

  fragmentsManager = components.get(OBC.FragmentsManager);
  fragmentsManager.onFragmentsLoaded.add(async (model) => {
    if (model.hasProperties) await indexer.process(model);
  });
  const [relationsTree] = CUI.tables.relationsTree({
    components,
    models: [],
  });

  relationsTree.preserveStructureOnFilter = true;

  const panel = BUI.Component.create(() => {
    const onSearch = (e: Event) => {
      const input = e.target as BUI.TextInput;
      relationsTree.queryString = input.value;
    };

    return BUI.html`
     <div id="relationsPanel" class="options-menu">
        <bim-text-input @input=${onSearch} placeholder="Search..." debounce="200"></bim-text-input>
        ${relationsTree}
     </div> 
    `;
  });
  const relationTreeDom = document.getElementById("relationTree");
  if (!relationTreeDom) return;
  relationTreeDom.innerHTML = "";
  relationTreeDom.append(panel);
  hasPanels.relations = true;
};

// 销毁模型
export const disposeModel = () => {
  fragmentsManager = world.components.get(OBC.FragmentsManager);
  fragmentsManager?.dispose();
  fragmentIFCLoader = world.components.get(OBC.IfcLoader);
  fragmentIFCLoader?.dispose();
  streamerLoader = components.get(OBCF.IfcStreamer);
  streamerLoader?.dispose();
};

export const exploderModel = async (
  cbStatus: (v: boolean) => void,
  cb?: (v: boolean) => void
) => {
  const classifier = components.get(OBC.Classifier);
  if (modelsList.length == 0) {
    cb?.(false);
    return;
  }
  for (let i = 0; i < modelsList.length; i++) {
    await classifier.bySpatialStructure(modelsList[i], {
      isolate: new Set([WEBIFC.IFCBUILDINGSTOREY]),
    });
  }
  const exploder = await components.get(OBC.Exploder);
  const newStatus: boolean = !hasPanels.exploder;
  exploder.set(newStatus);
  hasPanels.exploder = newStatus;
  cb?.(true);
  cbStatus(hasPanels.exploder);
};

// 导出相关
export const exportPropertyJson = async (cb?: (v: boolean) => void) => {
  const exporter = components.get(OBC.IfcJsonExporter);
  const webIfc = new WEBIFC.IfcAPI();
  webIfc.SetWasmPath("https://unpkg.com/web-ifc@0.0.57/", true);
  await webIfc.Init();

  // 从url导出
  // const ifcFile = await fetch(
  //   "streamerFiles/zhongwu.ifc",
  // );
  // const ifcData = await ifcFile.arrayBuffer();
  // const ifcBuffer = new Uint8Array(ifcData);
  // const modelID = webIfc.OpenModel(ifcBuffer);
  if (!bufferList.length) {
    cb?.(false);
    return;
  }
  for (let i = 0; i < bufferList.length; i++) {
    const modelID = webIfc.OpenModel(bufferList[i]);
    const exported = await exporter.export(webIfc, modelID);
    const serialized = JSON.stringify(exported);
    const file = new File([new Blob([serialized])], `properties${i}.json`);
    download(file);
  }
};

// 导出关系json
export const exportRelationJson = async () => {
  const indexer = components.get(OBC.IfcRelationsIndexer);
  for (let i = 0; i < modelsList.length; i++) {
    await indexer.process(modelsList[i]);
    const allRelationsJSON = indexer.serializeAllRelations();
    const file = new File(
      [JSON.stringify(allRelationsJSON)],
      `relation${i}.json`
    );
    download(file);
  }
};

/**
 * 将IFC文件转换为frag文件并下载
 * 将导出的数据创建为Blob对象，文件名以当前时间戳为前缀，后缀为".frag"。
 */
export const exportToFrag = async (cb?: (v: boolean) => void) => {
  fragmentsManager = components.get(OBC.FragmentsManager);
  if (!fragmentsManager.groups.size) {
    cb?.(false);
    return;
  }
  const uuidList = modelsList.map((model) => model.uuid);
  for (var i = 0; i < uuidList.length; i++) {
    const group = fragmentsManager.groups.get(uuidList[i]);
    if (!group) {
      cb?.(false);
      return;
    }
    const data = fragmentsManager.export(group);
    const blob = new Blob([data]);
    const time = new Date().getTime();
    const file = new File([blob], `${time}-ifcToFrag${i}.frag`);
    download(file);
  }
};

/**
 * 下载文件
 *
 * @param file 要下载的文件对象
 */
function download(file: File) {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(file);
  link.download = file.name;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

/**
 * 导出流片段文件集
 *
 * @param cb 回调函数，当导出流片段完成时调用。参数为布尔值，表示是否成功完成
 */

export const exportStreamFiles = async (cb?: (v: boolean) => void) => {
  if (modelsList.length == 0) {
    cb?.(false);
    return;
  }
  const lastModelName =
    modelsList[modelsList.length - 1]?.name.split(".")[0] || "small";
  tiler = components.get(OBC.IfcGeometryTiler);
  const wasm = {
    path: "https://unpkg.com/web-ifc@0.0.55/",
    absolute: true,
  };

  tiler.settings.wasm = wasm;
  tiler.settings.minGeometrySize = 20;
  tiler.settings.minAssetsSize = 1000;

  let files: { name: string; bits: (Uint8Array | string)[] }[] = [];
  let geometriesData: OBC.StreamedGeometries = {};
  let geometryFilesCount = 1;

  tiler.onGeometryStreamed.add((geometry) => {
    // 生成分片文件
    const { buffer, data } = geometry;
    const bufferFileName = `${lastModelName}.ifc-processed-geometries-${geometryFilesCount}`;
    for (const expressID in data) {
      const value = data[expressID];
      value.geometryFile = bufferFileName;
      geometriesData[expressID] = value;
    }
    files.push({ name: bufferFileName, bits: [buffer] });
    geometryFilesCount++;
  });

  let assetsData: OBC.StreamedAsset[] = [];
  // 把新的颜色属性添加到assetsData所有属性集合里
  tiler.onAssetStreamed.add((assets) => {
    assetsData = [...assetsData, ...assets];
  });

  tiler.onIfcLoaded.add((groupBuffer) => {
    // 全局数据文件
    files.push({
      name: `${lastModelName}.ifc-processed-global`,
      bits: [groupBuffer],
    });
  });

  tiler.onProgress.add((progress) => {
    if (progress !== 1) return;
    setTimeout(async () => {
      const processedData = {
        geometries: geometriesData,
        assets: assetsData,
        globalDataFileId: `${lastModelName}.ifc-processed-global`,
      };
      files.push({
        name: `${lastModelName}.ifc-processed.json`,
        bits: [JSON.stringify(processedData)],
      });
      await downloadFilesSequentially(files);
      assetsData = [];
      geometriesData = {};
      files = [];
      geometryFilesCount = 1;
    });
  });

  if (bufferList.length == 0) {
    cb?.(false);
    return;
  }
  if (bufferList.length > 1) {
    message.warning(
      "注：场景中存在多个模型，本次只导出最后一次加载的模型流片段文件集！"
    );
  }
  const buffer = bufferList[bufferList.length - 1];
  await tiler.streamFromBuffer(buffer);
  cb?.(true);
};

/**
 * 导出分片属性文件
 * @param name
 * @param bits
 */
export const exportStreamProps = async (cb?: (v: boolean) => void) => {
  if (modelsList.length == 0) {
    cb?.(false);
    return;
  }
  const lastModelName =
    modelsList[modelsList.length - 1]?.name.split(".")[0] || "small";
  propsStreamer = components.get(OBC.IfcPropertiesTiler);

  propsStreamer.settings.wasm = {
    path: "https://unpkg.com/web-ifc@0.0.55/",
    absolute: true,
  };

  interface StreamedProperties {
    types: {
      [typeID: number]: number[];
    };

    ids: {
      [id: number]: number;
    };

    indexesFile: string;
  }

  /* MD
  So we will define an object where we will store the tiles as we generate them.
*/

  const jsonFile: StreamedProperties = {
    types: {},
    ids: {},
    indexesFile: `${lastModelName}.ifc-processed-properties-indexes`,
  };

  let counter = 0;

  const files: { name: string; bits: Blob }[] = [];

  propsStreamer.onPropertiesStreamed.add(async (props) => {
    if (!jsonFile.types[props.type]) {
      jsonFile.types[props.type] = [];
    }
    jsonFile.types[props.type].push(counter);

    for (const id in props.data) {
      jsonFile.ids[id] = counter;
    }

    const name = `${lastModelName}.ifc-processed-properties-${counter}`;
    const bits = new Blob([JSON.stringify(props.data)]);
    files.push({ bits, name });

    counter++;
  });

  propsStreamer.onProgress.add(async (progress) => {
    console.log(progress);
  });

  propsStreamer.onIndicesStreamed.add(async (props) => {
    files.push({
      name: `${lastModelName}.ifc-processed-properties.json`,
      bits: new Blob([JSON.stringify(jsonFile)]),
    });

    const relations = components.get(OBC.IfcRelationsIndexer);
    const serializedRels = relations.serializeRelations(props);

    files.push({
      name: `${lastModelName}.ifc-processed-properties-indexes`,
      bits: new Blob([serializedRels]),
    });

    await downloadFilesSequentially(files);
  });
  const buffer = bufferList[bufferList.length - 1];
  await propsStreamer.streamFromBuffer(buffer);
  cb?.(true);
};

function downloadFile(name: string, ...bits: (Uint8Array | string)[]) {
  const file = new File(bits, name);
  const anchor = document.createElement("a");
  const url = URL.createObjectURL(file);
  anchor.href = url;
  anchor.download = file.name;
  anchor.click();
  URL.revokeObjectURL(url);
}

async function downloadFilesSequentially(
  fileList: { name: string; bits: any }[]
) {
  for (const { name, bits } of fileList) {
    downloadFile(name, bits);
    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });
  }
}

/**
 * 加载模型关系数据
 *
 * @param relationsFileData 包含关系数据的字符串
 * @param fileName 可选，指定模型文件名，如果不提供，则默认使用最后一个模型
 * @returns 无返回值
 */
export const loadRelations = async (
  relationsFileData: string,
  fileName?: string
) => {
  // Lets first delete the existing model relations
  const model = fileName
    ? modelsList.find((b) => (b.name = fileName))
    : modelsList[modelsList.length - 1];
  if (!model) return;
  const indexer = components.get(OBC.IfcRelationsIndexer);
  delete indexer.relationMaps[model.uuid];
  const relationsIndex = indexer.getRelationsMapFromJSON(relationsFileData);
  indexer.setRelationMap(model, relationsIndex);
};

// 载入属性json数据
export const loadPropertys = async (
  propsFileData: string,
  fileName?: string
) => {
  const model = fileName
    ? modelsList.find((b) => (b.name = fileName))
    : modelsList[modelsList.length - 1];
  model.setLocalProperties(propsFileData);
};

const suIfc = (() => {
  class suIfcClass {
    /**
     * @param  {el} 容器ID
     * @param  {op} 配置信息
     */
    constructor(el: string, option?: any) {
      if (option) {
        options = { ...options, ...option };
      }

      container = document.getElementById(el);
      initial();
    }
  }
  return suIfcClass;
})();
export { suIfc };
